import { track } from '@eventbrite/datalayer-library';
import { logEvent } from '@eventbrite/statsig';
import classNames from 'classnames';
import React, { FunctionComponent, useEffect } from 'react';
import { HeapEventName } from '../../../constants/heap';
import { STATSIG_EVENT_NAMES } from '../../../constants/statsig';
import type { ExpressCheckoutSubmitDataType } from '../../../models/expressCheckout';
import { StatsigValueType } from '../../../models/expressCheckout';
import { TicketsPageSize } from '../../../models/ticketsPage';
import './ApplepayNativeButton.scss';

export interface ApplepayNativeButtonProps {
    canMakePaymentsWithActiveCard: boolean;
    defaultLocale: string;
    handleSubmit: (props: ExpressCheckoutSubmitDataType) => void;
    pathname?: string;
    ticketsCost: number;
    ticketsPageSize: TicketsPageSize;
}

export const ApplepayNativeButton: FunctionComponent<
    ApplepayNativeButtonProps
> = ({
    canMakePaymentsWithActiveCard,
    defaultLocale,
    handleSubmit,
    pathname,
    ticketsCost,
    ticketsPageSize,
}) => {
    useEffect(() => {
        track({
            eventName: HeapEventName.applePayButtonView,
            eventData: {
                pathname,
            },
        });
    }, [pathname]);

    useEffect(() => {
        logEvent(STATSIG_EVENT_NAMES.APPLE_PAY_VIEW_BUTTON, null, {
            ticketsPageSize,
            pathname: pathname ?? '',
        });
    }, [pathname, ticketsPageSize]);

    return (
        <button
            id="apple-pay-native-checkout-button"
            onClick={() =>
                handleSubmit({
                    isApplePay: true,
                    statsigValue: StatsigValueType.APPLE_PAY,
                })
            }
            className={classNames(
                'apple-pay-button-with-text apple-pay-button-black-with-text ',
                {
                    'apple-pay-button-with-setup-text':
                        canMakePaymentsWithActiveCard === false,
                    'apple-pay-button-with-pay-text':
                        ticketsCost > 0 &&
                        canMakePaymentsWithActiveCard === true,
                },
            )}
            lang={defaultLocale}
            type="button"
        >
            <span className="text"></span>
            <span className="logo"></span>
        </button>
    );
};
